import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'search-pagination',
    templateUrl: './search-pagination.component.html',
    styleUrls: ['./search-pagination.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchPaginationComponent {

  @Input()  paginationData: any;
  @Output() paginationDataChange = new EventEmitter<any>();
 
  @Output()
  selectedPage:EventEmitter<Object> = new EventEmitter();

  constructor() { }

  paginateTo(pageIndex, source){
    this.selectedPage.emit({pageIndex: pageIndex, source: source});
  }
}
